import styled, { css } from 'styled-components';

import Tooltip from '~/components/Tooltip';

interface SelectBlockProps {
  isFocused: boolean;
  isErrored: boolean;
  isDisabled?: boolean;
}

interface SelectLabelProps {
  isFocused: boolean;
}

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;
`;

export const SelectBlock = styled.div<SelectBlockProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  background: ${(props) => (props.isDisabled ? '#E0E0E0' : '#ffffff')};
  width: 100%;
  height: 5rem;
  border: 0.5px solid #707070;
  border-radius: 4rem;
  transition: all 0.2s ease-in-out;
  margin-bottom: 8px;
  z-index: 0;
  font-weight: 400;
  color: #000000;
  letter-spacing: 0.28px;
  padding: 0 1rem;
  transition: all 0.2s ease-in-out;

  ${(props) =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  /* Se o input estiver focado, mude a cor do icone e da borda. A cor do icone esta conectado com color */
  ${(props) =>
    props.isFocused &&
    css`
      color:   border: 1px solid #e4007d;
      border-color:   border: 1px solid #e4007d;
    `}

  ${(props) =>
    props.isDisabled &&
    css`
      border-color: #707070;
      color: #00000050 !important;
    `}
`;

export const SelectField = styled.select<SelectLabelProps>`
  appearance: none;
  all: unset;
  width: 100%;
  padding: 1rem 2.1rem;

  option {
    font-size: 1.4rem;
    font-weight: 400;
    color: #000000;
    letter-spacing: 0.28px;
  }
`;

export const SelectError = styled(Tooltip)`
  height: 20px;

  svg {
    margin-right: 0;
    margin-left: 15px;
  }
`;

export const Label = styled.label`
  font-size: 1.4rem;
  color: ${({ theme }) => theme.colors.black};
  opacity: 0.65;
  padding: 0 0 0.6rem 1.2rem;
  user-select: none;
`;
